import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import HomeForecastPage from "./pages/HomeForecastPage";
import TimelineHelpPage from "./pages/TimelineHelpPage";

const DayDetailPage = lazy(() => import("./pages/DayDetailPage"));

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeForecastPage />} />
      <Route path="/help/timeline" element={<TimelineHelpPage />} />
      <Route
        path="/day/:date"
        element={
          <Suspense fallback={null}>
            <DayDetailPage />
          </Suspense>
        }
      />
    </Routes>
  );
}
